/* eslint-disable */
import React from 'react';

// TODO: Fix eslint issues.

const Checkbox = React.forwardRef(({
  children, className, name, id, ...rest
},ref) => {
  return (
    <label
      htmlFor={id}
      className={`checkbox ${className}`}
    >
      <input
        type="checkbox"
        id={id}
        name={name}
        ref={ref}
        {...rest}
      />
      <label
        htmlFor={id}
        className="cursor-pointer"
      />
    </label>
  );
});

export default Checkbox;
